module.exports = __webpack_public_path__ + "Poppins-Italic.8d3743ef9e185c44a5cb.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-Italic.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-Italic.woff
// module chunks = styles